export var AlertLevel;
(function (AlertLevel) {
    AlertLevel["INFO"] = "INFO";
    AlertLevel["WARNING"] = "WARNING";
})(AlertLevel || (AlertLevel = {}));
//# sourceMappingURL=alertInfo.js.map